/**
 * A key numeral pinned to one part of a worked example.
 *
 * A superscript rather than a badge in the flow: the card's identity band is a single row that
 * already truncates under pressure, and badges of their own width would push the marks off a
 * phone. Hidden from assistive technology because it is a pointer into the prose, and the prose
 * names every part in words as well.
 */
export function Key({ n }: { n: number }) {
  return (
    <sup className="help-example-key" aria-hidden>
      {n}
    </sup>
  );
}
